import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem 2rem;
    margin: auto;
    width: 100%;
    max-width: 32.5rem;
    height: 100%;
    max-height: 32rem;
    border-radius: 1rem;
    position: relative;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};

    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);

    > p {
      text-align: center;
      margin: 1rem 0 2rem;

      + button {
        margin-top: auto;
      }
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
`;
